












import { Vue, Component, Mixins } from "vue-property-decorator";

@Component
export default class extends Mixins() {
  latestEnterapply: any[] = [];
  loading: boolean = false;

  async loadLatestEnterapply() {
    this.loading = true;
    const res = await this.$store.dispatch("statistics/latestEnterapply", {});
    if (res && res.Data && res.Data !== "{}") {
      this.latestEnterapply = res.Data;
    }
    this.loading = false;
  }

  mounted() {
    this.loadLatestEnterapply();
  }
}
